// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setISOWeek as fn } from "../setISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setISOWeek = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setISOWeek;
